import { createAction, createReducer } from 'redux-act';
import { fetchMySchneiderCountries } from '../../utils/service-http';


/**
 * Reducer and action used to retrieve My Schneider countries.
 */
const DEFAULT_STATE = [];

export const getMySchneiderCountriesSuccess = createAction('GET_MS_COUNTRIES_SUCCESS');
export const getMySchneiderCountriesFailed = createAction('GET_MS_COUNTRIES_FAILED');


export const mySchneiderCountriesReducer = createReducer(function (on, off) {
  on(getMySchneiderCountriesSuccess, (state, payload) => {
    return payload
  });
  on(getMySchneiderCountriesFailed, (state, payload) => {
    return []
  });
}, DEFAULT_STATE);

export const getMySchneiderCountries = () => {
  return async dispatch => {
    return fetchMySchneiderCountries().then((countries => {
      dispatch(getMySchneiderCountriesSuccess(countries));
      return countries;
    })).catch(() => {
      dispatch(getMySchneiderCountriesFailed());
      return [];
    });
  }
}
